<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary" icon="edit">
            ثبت کاربر </a-button>

        <a-modal width="1000px" v-model="visible" title=" ویرایش مهمان" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>

            </template>
                        <form @submit.prevent="addData($event)">

            <div class="row">

                <div class="col-md-4 my-1">
                    <div class="form-group text-right">
                        <label for=""> شماره موبایل</label>
                        <input name="phone" v-model="data.phone" disabled type="number" class="form-control">


                    </div>
                </div>
                
                <div class="col-md-4 my-1">
                    <div class="form-group text-right">
                        <label for=""> نام خانوادگی</label>
                        <input name="family"  v-model="data.family" type="text" class="form-control">


                    </div>
                </div>
                <div class="col-md-4 my-1">
                    <div class="form-group text-right">
                        <label for=""> نام</label>
                        <input name="name"  v-model="data.name" type="text" class="form-control">


                    </div>
                </div>
              
                <div class="col-md-4 my-1">
                    <div class="form-group text-right">
                        <label for=""> تماس گیرنده</label>
                        <input disabled="disabled" :value="data.caller ? data.caller.firstname+' '+data.caller.lastname : '' " type="text" class="form-control">

                    </div>
                </div>
              
                <div class="col-md-4 my-1">
                    <div class="form-group text-right">
                        <label for=""> تعداد همراه</label>
                        <input name="count"  v-model="data.count" type="number" class="form-control">

                    </div>
                </div>

                 <div class="col-md-4 my-1">
                    <div class="form-group text-right">
                        <label for="">  تلفن ثابت</label>
                        <input name="tel"  v-model="data.tel" type="text" class="form-control">

                    </div>
                </div>
                
                            
                 <a-divider orientation="right">انتخاب سمینار و سانس</a-divider>

                   
<div class="col-md-4">
                                   
                            </div>
                              <div class="col-md-4">
                                    <label class="sr-only" for="inline-form-input-name">
                                         سانس</label>
                                        <a-select mode="single"  style="width:100%" placeholder="انتخاب  سانس "
                                    v-model="data.sans_id">
                                    <a-select-option v-for="item in sans" :key="item.id" :value="item.id">
                                        {{ item . start_hour+'-'+item.end_hour }}
                                    </a-select-option>
                                </a-select>
                            </div>
<div class="col-md-4">
                                    <label class="sr-only" for="inline-form-input-name">
                                         سمینار</label>
                                        <a-select mode="single" @change="setSans" style="width:100%" placeholder="انتخاب  سمینار "
                                    v-model="data.seminar_id">
                                    <a-select-option  value="">
                                         انتخاب سمینار
                                    </a-select-option>
                                    <a-select-option v-for="seminar in seminars" :key="seminar.id" :value="seminar.id">
                                        {{ seminar . title }}
                                    </a-select-option>
                                </a-select>
                            </div>

                 <div class="col-md-12 my-1">
                    <div class="form-group text-right">
                        <label for="">  توضیحات</label>
                        <textarea name="description" v-model="data.description"  class="form-control"></textarea>

                    </div>
                </div>
                
               <div class="mt-1">
                    <button type="submit" class="btn btn-fill btn-outline-success ">
                        ذخیره
                    </button>
                </div>

            </div>

        </form>
        </a-modal>
    </div>
</template>
<script>
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

    export default {
         components: {
            datePicker: VuePersianDatetimePicker
        },
          props: {
            data: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
                seminars: [],
                sans: [],
            };
        },
        methods: {
            showModal() {
                this.visible = true;
            },
            defaulProfit() {
                let choosedRole = this.roles.find(x => x.id == this.seminar_role);
                this.info.profit_percent = choosedRole.profit_percent;
                //    return this.roles.find(x => x.id == this.seminar_role);
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
                this.$emit('getData')
            },
            
            
                addData(event) {
                let _this = this;
                let data = new FormData(event.target);
              
             
                if(this.data.seminar_id != undefined){
                data.append('seminar_id',this.data.seminar_id);
                }
                if(this.data.sans_id != undefined){
                data.append('sans_id',this.data.sans_id);
                }
                _this.$root.loading = true;
            
                axios
                    .post("/seminars/call/edit/" + this.data.id,data)
                    .then(function(response) {
                        console.log(response)
                        _this.$root.loading = false;
                        _this.$toast.success("   کاربر با موفقیت ویرایش شد   ");
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
                        
            async getUsers() {
                let _this = this;
                let url = '/seminars/all';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.seminars = response.data;
                        _this.setSans(_this.data.seminar_id)

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            setSans(){
                const result = this.seminars.find(({ id }) => id === this.data.seminar_id);
                this.sans=result.sans
                console.log('-------result-------')
                console.log(result)

            }
        },
        mounted() {
            this.getUsers()
        }
    };
</script>
